// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oW3wV","col":"styles_col__sUgsP"};